import { useAppContext } from "../context/appContext"
import Wrapper from "../assets/wrappers/MonthBtnContainer"

const MonthBtnContainer = () => {
    const {
        monthToDisplay,
        changeMonthToDisplay,
    } = useAppContext()

    const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    function returnMonthButton(monthNumber) {
        return <button
            className={monthToDisplay === parseInt(monthNumber) ? 'monthBtn active' : 'monthBtn'}
            key={monthNumber}
            onClick={() => {
                changeMonthToDisplay(parseInt(monthNumber))
            }}
            type="button">
            {monthNumber}
        </button>
    }

    return (
        <Wrapper>
            {
                <div
                    className="btn-container">
                    <div className="btn-row">
                        {
                            months.map((month, index) => {
                                if (index < 6) {
                                    return returnMonthButton(month)
                                }
                            })
                        }
                    </div>
                    <div className="btn-row">
                        {
                            months.map((month, index) => {
                                if (index >= 6) {
                                    return returnMonthButton(month)
                                }
                            })
                        }
                    </div>

                </div>
            }
        </Wrapper >
    )
}

export default MonthBtnContainer